import { render, staticRenderFns } from "./EfficiencyPercentage.vue?vue&type=template&id=77293fd2"
import script from "./EfficiencyPercentage.vue?vue&type=script&lang=js"
export * from "./EfficiencyPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports